var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WindowFrame',{ref:"windowframe_check",staticClass:"ma-0 pa-0",attrs:{"component":'check',"input_args":_vm.input_args},on:{"loaded":_vm.handleCheckLoaded}})
}
var staticRenderFns = []

export { render, staticRenderFns }